// extracted by mini-css-extract-plugin
export var deleteIcon = "_jj-5";
export var deleteOption = "_jj-3";
export var divider = "_jj-2";
export var downloadIcon = "_jj-4";
export var drawer = "_jj-0";
export var drawerFooter = "_jj-6";
export var drawerOpen = "_jj-1";
export var highlighted = "_jj-7";
export var lighterHighlight = "_jj-8";